/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online histogram maker. Paste a list of numbers to bin them automatically and see the frequency distribution as a histogram.`)
};

const es_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de histogramas online. Pega una lista de números para agruparlos automáticamente en intervalos y ver la distribución de frecuencias como un histograma.`)
};

const de_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Histogramm-Ersteller. Fügen Sie eine Liste von Zahlen ein, um sie automatisch in Klassen einzuteilen und die Häufigkeitsverteilung als Histogramm zu sehen.`)
};

const nl_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online histogrammaker. Plak een lijst getallen om ze automatisch in te delen en de frequentieverdeling als histogram te zien.`)
};

const fr_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit d'histogramme en ligne. Collez une liste de nombres pour les regrouper automatiquement en classes et voir la distribution de fréquence sous forme d'histogramme.`)
};

const it_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di istogrammi online. Incolla un elenco di numeri per raggrupparli automaticamente in classi e vedere la distribuzione di frequenza come istogramma.`)
};

const pt_br2_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de histograma. Cole uma lista de números para agrupá-los automaticamente em faixas e ver a distribuição de frequência como um histograma.`)
};

const pt_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de histogramas online. Cole uma lista de números para os agrupar automaticamente e ver a distribuição de frequências como um histograma.`)
};

const ja_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインヒストグラム作成ツール。数値のリストを貼り付けると自動的にビンに分割され、頻度分布がヒストグラムとして表示されます。`)
};

const zh_hist_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线直方图制作工具。粘贴一组数字，自动分箱并以直方图形式展示频率分布。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_meta_description", locale)
	if (locale === "en") return en_hist_meta_description(inputs)
	if (locale === "es") return es_hist_meta_description(inputs)
	if (locale === "de") return de_hist_meta_description(inputs)
	if (locale === "nl") return nl_hist_meta_description(inputs)
	if (locale === "fr") return fr_hist_meta_description(inputs)
	if (locale === "it") return it_hist_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_hist_meta_description(inputs)
	if (locale === "pt") return pt_hist_meta_description(inputs)
	if (locale === "ja") return ja_hist_meta_description(inputs)
	return zh_hist_meta_description(inputs)
};